import { OffertResponse } from "../prepare.offert.model.dto";

//!!! IMPORTANT odpowiednik tego enuma znajduje się w \otp-backend\src\OTP.BuildingBlocks.Domain\TransactionIdConverter.cs - 
//!!! w przypadku zmiany wartości należy pamiętać o zmianie w obu miejscach
export enum SpecialHandlingBrokers {
    TRASTI = "TRASTI"
} 

export interface PaymentScheduleCase {
    InstallmentNumber: number;
    PaymentDate: string;
    IsSelected: boolean;
    InstallmentAmount: number;
}

export interface Offert {
    LoanAmountGross: number;
    CKDZ: number;
    LoanAmountNet: number;
    Instalments: number;
    InterestRate: number;
    RRSO: number;
    InstalmentAmount: number;
    MinimalCommisionAmount: number;
    MininalAmountToPay: number;
    EarlyRRSO: number;
    PaymentDate: string;
    PaymentSchedule: PaymentScheduleCase[];
}

export interface TokenDataSuccessfulResponse {
    access_token: string;
    expires_in: number;
    token_type: string;
    scope: string;
    email: string;
    requestedAmount: number;
    offert: Offert;
    biillingCompany : string;
    successReturnUrl: string;
    failureReturnUrl: string;
    currentStatus: string;
    workflowId: number;
    hashedPhoneNumber?: string;
    maxLoanPeriod: number | null;
    specialHandlingBrokerName: SpecialHandlingBrokers | null;
}

export interface RecreateSuccesulResponse{
    access_token: string;
    expires_in: number;
    token_type: string;
    scope: string;
    offert: OffertResponse;
    billingCompany: string;
    phoneNumber: string;
    email: string;
    successReturnUrl: string;
    failureReturnUrl: string;
    workflowId: number
}

export function OffertCamelCase(offert : Offert) : OffertResponse{
    const schedule = offert.PaymentSchedule.map(p=>{ 
        return {
            installmentNumber: p.InstallmentNumber,
            paymentDate: new Date(p.PaymentDate).toISOString(),
            isSelected: p.IsSelected,
            installmentAmount: p.InstallmentAmount,
        }
    })
    
    return {
        ckdz: offert.CKDZ,
        paymentDate: new Date(offert.PaymentDate).toISOString(),
        instalmentAmount: offert.InstalmentAmount,
        interestRate: offert.InterestRate,
        mininalAmountToPay : offert.MininalAmountToPay,
        earlyRRSO : offert.EarlyRRSO,
        rrso : offert.RRSO,
        minimalCommisionAmount : offert.MinimalCommisionAmount,
        loanAmountGross : offert.LoanAmountGross,
        loanAmountNet : offert.LoanAmountNet,
        instalments: offert.Instalments,
        paymentSchedule : schedule
    }
}